
import {defineComponent, ref} from "vue";
import MovieRating from "@/components/MovieRating.vue";
import {getMovieDetails, imgUrl, youtubeUrl} from "@/service/MoviesService";

export default defineComponent({
  name: "MovieModal",
  components: {MovieRating},
  emits: ['closeModal'],
  props: {
    id: {
      type: Number,
      required: false,
      default: null
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    id(newId) {
      this.getMovieData(newId);
    },
    showModal(newValue) {
      this.changeModalVisibility(newValue)
    }
  },
  setup(props, {emit}) {
    const movie = ref();
    const show = ref(props.showModal)
    const showTrailer = ref(false);
    const movieId = ref(props.id)

    const dateFormat = (date: string) => {
      const newDate = new Date(date);
      return `${newDate.getDay()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`;
    }

    const openTrailer = () => {
      showTrailer.value = true;
    }

    const getMovieData = (id: number) => {
      const response = getMovieDetails(id);
      response.then(response => {
        movie.value = response.data;
        show.value = true;
      })
    }

    const imdbUrl = (id: string) => `https://www.imdb.com/title/${id}/`;

    const changeModalVisibility = (visibility: boolean) => show.value = visibility

    const overlayClicked = () => {
      emit('closeModal')
      showTrailer.value = false;
      changeModalVisibility(false);
      movie.value = false
    }

    return {
      movieId,
      movie,
      show,
      changeModalVisibility,
      overlayClicked,
      imdbUrl,
      showTrailer,
      openTrailer,
      dateFormat,
      imgUrl,
      youtubeUrl,
      getMovieData
    }
  }
})
